<template>
  <div id="createQuestions">
    <div class="createQuestions-item">
      <h2 style="color: #286695;">יצירת קובץ שאלות</h2>
    </div>
    <template class="verdict-form createQuestions-item">
      <form @submit.prevent="onSubmit()" class="form">
        <div class="link-container">
          <input type="radio" v-model="isExercise" :value="false">קורס
          <input type="radio" v-model="isExercise" :value="true">תרגולים
        </div>
        <b-taginput v-if="isExercise" v-model="exercises" ellipsis icon="label" 
          placeholder="הזן מספרי תרגולים (הפרד בפסיק או Enter)"
          aria-close-label="מחק תרגולים"
          :separator="[',', ';', ' ']"
          :allow-duplicates="false"
          style="width: 350px;">
        </b-taginput>
        <input style="width: 350px;" v-else type="text" v-model="course" placeholder="הזן מספר קורס">
        <button class="button-style" :disabled="isLoading" type="submit">
          {{ isLoading ? 'מייצא...' : 'ייצא שאלות' }}
        </button>
      </form>
    </template>
  </div>
</template>

<script>
import { ToastProgrammatic as Toast } from 'buefy';
import AdminService from '../services/AdminService';

export default {
  name: 'createQuestions',
  data: function () {
    return {
      isLoading: false,
      isExercise: false,
      exercises: [],
      course: null
    }
  },
  methods: {
    onSubmit() {
      if (!this.validateInput()) {
        return;
      }

      this.isLoading = true;
      
      const exportData = this.isExercise ? 
        (this.exercises.length === 1 ? { ExerciseId: this.exercises[0] } : { ExerciseIds: this.exercises }) : 
        { CourseId: this.course };
      console.log(exportData);
      AdminService.exportExerciseQuestion(exportData)
        .then((response) => {
          console.log(response.data);
          this.downloadFile(response.data);
          this.resetForm();
          Toast.open({
            type: 'is-success',
            message: 'קובץ השאלות יוצא בהצלחה!',
            position: 'is-top',
            duration: 4000
          });
        })
        .catch((error) => {
          console.log(error);
          Toast.open({
            type: 'is-danger',
            message: 'פעולה נכשלה! בדוק את הנתונים שהוזנו.',
            position: 'is-top',
            duration: 8000
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

     validateInput() {
       if (this.isExercise && (!this.exercises || this.exercises.length === 0)) {
         Toast.open({
           type: 'is-warning',
           message: 'אנא הזן לפחות מספר תרגול אחד',
           position: 'is-top',
           duration: 4000
         });
         return false;
       }
      
      if (!this.isExercise && (!this.course || this.course.trim() === '')) {
        Toast.open({
          type: 'is-warning',
          message: 'אנא הזן מספר קורס',
          position: 'is-top',
          duration: 4000
        });
        return false;
      }
      
      return true;
    },

     downloadFile(blob) {
       const href = URL.createObjectURL(blob);
       const fileName = this.isExercise ? 
         `questions_exercises_${this.exercises.join('_')}.xlsx` : 
         `questions_course_${this.course}.xlsx`;
      
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    },

     resetForm() {
       this.exercises = [];
       this.course = null;
       this.isExercise = false;
     }
  }
}
</script>

<style>
#createQuestions {
  max-width: unset;
  width: 100%;
  padding: 20px;
  color: #333;
  display: flex;
  flex-direction: column;
}

.has-ellipsis {
  max-width: 10em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tag {
  margin-left: 0.275rem;
  margin-bottom: calc(0.275em - 1px);
  font-size: .9em;
  height: calc(2em - 1px);
}

.tag:not(body) {
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #4a4a4a;
  display: inline-flex;
  font-size: .75rem;
  height: 2em;
  justify-content: center;
  line-height: 1.5;
  padding-left: 0.75em;
  padding-right: 0.75em;
  white-space: nowrap;
}

.tag .delete:before,
.modal-close:before {
  height: 2px;
  width: 50%;
  background-color: #fff;
  content: "";
  display: block;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  transform-origin: center center;
}

.tag .delete:after,
.modal-close:after {
  height: 50%;
  width: 2px;
  background-color: #fff;
  content: "";
  display: block;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  transform-origin: center center;
}

#createQuestions>form>div.taginput.control>div>span>a {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background-color: hsla(0, 0%, 4%, .2);
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  pointer-events: auto;
  display: inline-block;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 0;
  height: 20px;
  max-height: 20px;
  max-width: 20px;
  min-height: 20px;
  min-width: 20px;
  outline: none;
  position: relative;
  vertical-align: top;
  width: 20px;
}

.createQuestions-item {
  width: 50%;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.link-container {
  display: flex;
  align-items: center;
  gap: 15px;
}

.link-container input[type="radio"] {
  margin-left: 8px;
}

.form textarea,
.form input[type="text"] {
  border-radius: 7px;
  font-size: 20px;
  padding: 0 5px;
  resize: vertical;
  width: 100%;
}

.form input[type="text"] {
  border: 1px solid rgb(118, 118, 118);
  padding: 15px 5px;
  background-color: #fff;
  font-size: 16px;
}

.button-style {
  background-color: #286695;
  padding: 15px;
  color: white;
  border-radius: 7px;
  width: fit-content;
  border: none;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.button-style:hover:not(:disabled) {
  background-color: #1e5577;
}

.button-style:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

#createQuestions h2 {
  margin: 20px 0;
}

#createQuestions h1,
#createQuestions h2,
#createQuestions h3 {
  margin-block-start: 0.67em;
  margin-block-end: 0.67em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  color: #111;
  font-size: 2em;
}
</style>

<style scoped>
.button .icon,
.button .icon.is-small,
.button .icon.is-medium,
.button .icon.is-large {
  height: 1.5em;
  width: 1.5em;
}

.button.is-small {
  font-size: 0.75rem;
}

.delete.is-small {
  margin-left: 0.25rem;
  margin-right: -0.375rem;
}

.is-small.delete,
.is-small.modal-close {
  height: 16px;
  max-height: 16px;
  max-width: 16px;
  min-height: 16px;
  min-width: 16px;
  width: 16px;
}

.delete,
.modal-close {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background-color: hsla(0, 0%, 4%, .2);
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  pointer-events: auto;
  display: inline-block;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 0;
  height: 20px;
  max-height: 20px;
  max-width: 20px;
  min-height: 20px;
  min-width: 20px;
  outline: none;
  position: relative;
  vertical-align: top;
  width: 20px;
}
</style>

<style>
#mainDisplay {
  right: 180px;
  width: calc(100% - 180px);
}
</style>
